export const TARGETING_TYPE = {
  New: 'New',
  Included: 'Included',
  Excluded: 'Excluded',
  Recommended: 'Recommended',
  Top: 'Top',
};
